import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { AuthModal } from "./components/AuthModal";
import { PaymentPoller } from "./components/PaymentPoller";
import { GoogleAuthCallback } from "./components/GoogleAuthCallback";
import { Toaster } from "sonner";
import { TokenWatcher } from "./hooks/useTokenWatcher";
import {
  ScrollProgressBar,
  ScrollRevealObserver,
  SmoothScrollAnchors,
} from "./components/CinematicEffects";
import { MenuOverlayController } from "./components/MenuOverlayController";
import { Navbar } from "./components/Navbar";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { HeroSection } from "./components/HeroSection";
import { TrendIASection } from "./components/TrendIASection";
import { TopWalletSection } from "./components/TopWalletSection";
import { CtaBand } from "./components/CtaBand";
import { ConnectWithRebel } from "./components/ConnectWithRebel";
import { MissionBriefingModal } from "./components/MissionBriefingModal";
import { Footer } from "./components/Footer";
import { SEO } from "./components/SEO";
import AcademyPage from "./pages/AcademyPage";import AcademyPatronesPage from "./pages/AcademyPatronesPage";
import LearnToEarnPage from "./pages/LearnToEarnPage";
import LiquidityMapPage from "./pages/LiquidityMapPage";
import CyclesMapPage from "./pages/CyclesMapPage";
import DcaSimulatorPage from "./pages/DcaSimulatorPage";
import AdminPage from "./pages/AdminPage";
import AcademyPatronDetailPage from "./pages/AcademyPatronDetailPage";
import AcademyCalculadoraPage from "./pages/AcademyCalculadoraPage";
import AcademyGlosarioPage from "./pages/AcademyGlosarioPage";
import AcademyEstrategiasPage from "./pages/AcademyEstrategiasPage";
import AcademyEstrategiaDetailPage from "./pages/AcademyEstrategiaDetailPage";
import AcademyPsicologiaPage from "./pages/AcademyPsicologiaPage";
import AcademyPsicologiaDetailPage from "./pages/AcademyPsicologiaDetailPage";
import AcademyOnchainPage from "./pages/AcademyOnchainPage";
import CasoEstudioPage from "./pages/CasoEstudioPage";
import KidsAcademyPage from "./pages/KidsAcademyPage";
import KidsLeccionPage from "./pages/KidsLeccionPage";
import KidsLogrosPage from "./pages/KidsLogrosPage";
import TopWalletComparadorPage from "./pages/TopWalletComparadorPage";
import TopWalletSeccionPage from "./pages/TopWalletSeccionPage";
import TopWalletArticuloPage from "./pages/TopWalletArticuloPage";
import TopWalletArticulosPage from "./pages/TopWalletArticulosPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ContactPage from "./pages/ContactPage";
import SimulatorPage from "./pages/SimulatorPage";
import SimulatorPlayPage from "./pages/SimulatorPlayPage";
import SimulatorResultsPage from "./pages/SimulatorResultsPage";
import SimulatorHistoryPage from "./pages/SimulatorHistoryPage";
import SimulatorLeaderboardPage from "./pages/SimulatorLeaderboardPage";
import BlogIndexPage from "./pages/BlogIndexPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import ShadowNetworkPage from "./pages/ShadowNetworkPage";
import RebelByEddyPage from "./pages/RebelByEddyPage";
import RebelByEddyDashboardPage from "./pages/RebelByEddyDashboardPage";
import ShadowRankingPage from "./pages/ShadowRankingPage";
import ShadowFeedPage from "./pages/ShadowFeedPage";
import ShadowProfilePage from "./pages/ShadowProfilePage";
import ShadowProfileEditPage from "./pages/ShadowProfileEditPage";
import ShadowMessagesPage from "./pages/ShadowMessagesPage";
import ShadowMessagesChatPage from "./pages/ShadowMessagesChatPage";
import ShadowNotificationsPage from "./pages/ShadowNotificationsPage";
import ShadowAlertsPage from "./pages/ShadowAlertsPage";
import ShadowJournalPage from "./pages/ShadowJournalPage";
import ShadowMonetizaPage from "./pages/ShadowMonetizaPage";
import ShadowMentorPage from "./pages/ShadowMentorPage";
import ShadowChallengesPage from "./pages/ShadowChallengesPage";
import ShadowTokensPage from "./pages/ShadowTokensPage";
import ShadowSubscriptionsRblPage from "./pages/ShadowSubscriptionsRblPage";
import ShadowPostPage from "./pages/ShadowPostPage";
import ShadowListsPage from "./pages/ShadowListsPage";
import ShadowListDetailPage from "./pages/ShadowListDetailPage";
import ShadowSavedPage from "./pages/ShadowSavedPage";
import ShadowSearchPage from "./pages/ShadowSearchPage";
import ShadowMarketPage from "./pages/ShadowMarketPage";
import ShadowMarketProductPage from "./pages/ShadowMarketProductPage";
import ShadowMarketCartPage from "./pages/ShadowMarketCartPage";
import ShadowMarketConfirmPage from "./pages/ShadowMarketConfirmPage";
import ShadowMarketCustomizePage from "./pages/ShadowMarketCustomizePage";
import VerifyPage from "./pages/VerifyPage";
import WhitepaperPage from "./pages/WhitepaperPage";
import SecurityAuditPage from "./pages/SecurityAuditPage";
import VaultPage from "./pages/VaultPage";
import AdminVaultPage from "./pages/AdminVaultPage";
import GovernancePage from "./pages/GovernancePage";
import AdminGovernancePage from "./pages/AdminGovernancePage";
import { CartProvider } from "./contexts/CartContext";
import { ShopCartDrawer } from "./components/ShopCartDrawer";
import { AnalyticsRouteTracker } from "./components/AnalyticsRouteTracker";
import { ImageLightboxProvider } from "./components/ImageLightbox";
import { TeamSection } from "./components/team/TeamSection";
import { RBLSection } from "./components/home/RBLSection";
import LiqScoreHomeCard from "./components/home/LiqScoreHomeCard";

const Landing = () => (
  <div className="min-h-screen bg-black text-white antialiased" data-testid="app-root">
    <Navbar />
    <main>
      <h1 className="sr-only">
        REBEL · Ecosistema Crypto con IA · TrendIA app de trading con inteligencia
        artificial y TopWallet plataforma educativa Web3 sobre blockchain, DeFi y wallets.
      </h1>
      <HeroSection />
      <RBLSection />
      <LiqScoreHomeCard />
      <TrendIASection />
      <TopWalletSection />
      <ConnectWithRebel />
      <TeamSection />
      <CtaBand />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <CartProvider>
        <ImageLightboxProvider>
        <BrowserRouter>
          <SEO />
          <AnalyticsRouteTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/academy" element={<AcademyPage />} />
            <Route path="/learn-to-earn" element={<LearnToEarnPage />} />
            <Route path="/liquidity-map" element={<LiquidityMapPage />} />
            <Route path="/liquidity-map/cycles" element={<CyclesMapPage />} />
            <Route path="/liquidity-map/dca" element={<DcaSimulatorPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/academy/patrones" element={<AcademyPatronesPage />} />
            <Route path="/academy/patrones/:id" element={<AcademyPatronDetailPage />} />
            <Route path="/academy/calculadora" element={<AcademyCalculadoraPage />} />
            <Route path="/academy/glosario" element={<AcademyGlosarioPage />} />
            <Route path="/academy/estrategias" element={<AcademyEstrategiasPage />} />
            <Route path="/academy/estrategias/:id" element={<AcademyEstrategiaDetailPage />} />
            <Route path="/academy/psicologia" element={<AcademyPsicologiaPage />} />
            <Route path="/academy/psicologia/:id" element={<AcademyPsicologiaDetailPage />} />
            <Route path="/academy/onchain" element={<AcademyOnchainPage />} />
            <Route path="/academy/lab-mercado/:slug" element={<CasoEstudioPage />} />
            <Route path="/kids" element={<KidsAcademyPage />} />
            <Route path="/kids/leccion/:id" element={<KidsLeccionPage />} />
            <Route path="/kids/logros" element={<KidsLogrosPage />} />
            <Route path="/topwallet/comparador" element={<TopWalletComparadorPage />} />
            <Route path="/topwallet/articulos" element={<TopWalletArticulosPage />} />
            <Route path="/topwallet/:seccion/:slug" element={<TopWalletArticuloPage />} />
            <Route path="/topwallet/:seccion" element={<TopWalletSeccionPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/simulator" element={<SimulatorPage />} />
            <Route path="/simulator/play" element={<SimulatorPlayPage />} />
            <Route path="/simulator/results" element={<SimulatorResultsPage />} />
            <Route path="/simulator/history" element={<SimulatorHistoryPage />} />
            <Route path="/simulator/leaderboard" element={<SimulatorLeaderboardPage />} />
            <Route path="/blog" element={<BlogIndexPage />} />
            <Route path="/blog/:slug" element={<BlogArticlePage />} />
            <Route path="/shadow" element={<ShadowNetworkPage />} />
            <Route path="/rebel-by-eddy" element={<RebelByEddyPage />} />
            <Route path="/rebel-by-eddy/dashboard" element={<RebelByEddyDashboardPage />} />
            <Route path="/shadow/ranking" element={<ShadowRankingPage />} />
            <Route path="/shadow/feed" element={<ShadowFeedPage />} />
            <Route path="/shadow/buscar" element={<ShadowSearchPage />} />
            <Route path="/shadow/guardados" element={<ShadowSavedPage />} />
            <Route path="/shadow/notificaciones" element={<ShadowNotificationsPage />} />
            <Route path="/shadow/alertas" element={<ShadowAlertsPage />} />
            <Route path="/shadow/journal" element={<ShadowJournalPage />} />
            <Route path="/shadow/monetiza" element={<ShadowMonetizaPage />} />
            <Route path="/shadow/mentor" element={<ShadowMentorPage />} />
            <Route path="/shadow/desafios" element={<ShadowChallengesPage />} />
            <Route path="/shadow/challenges" element={<ShadowChallengesPage />} />
            <Route path="/shadow/tokens" element={<ShadowTokensPage />} />
            <Route path="/shadow/subscripciones-rbl" element={<ShadowSubscriptionsRblPage />} />
            <Route path="/shadow/rbl-subscriptions" element={<ShadowSubscriptionsRblPage />} />
            <Route path="/shadow/post/:id" element={<ShadowPostPage />} />
            <Route path="/shadow/listas" element={<ShadowListsPage />} />
            <Route path="/shadow/listas/:listId" element={<ShadowListDetailPage />} />
            <Route path="/shadow/perfil/editar" element={<ErrorBoundary><ShadowProfileEditPage /></ErrorBoundary>} />
            <Route path="/shadow/perfil/:username" element={<ErrorBoundary><ShadowProfilePage /></ErrorBoundary>} />
            <Route path="/shadow/mensajes" element={<ErrorBoundary><ShadowMessagesPage /></ErrorBoundary>} />
            <Route path="/shadow/mensajes/:userId" element={<ErrorBoundary><ShadowMessagesChatPage /></ErrorBoundary>} />
            <Route path="/shadow-market" element={<ShadowMarketPage />} />
            <Route path="/shadow-market/carrito" element={<ShadowMarketCartPage />} />
            <Route path="/shadow-market/pedido-confirmado" element={<ShadowMarketConfirmPage />} />
            <Route path="/shadow-market/personalizar/:slug" element={<ShadowMarketCustomizePage />} />
            <Route path="/shadow-market/:slug" element={<ShadowMarketProductPage />} />
            <Route path="/verify" element={<VerifyPage />} />
            <Route path="/verify/:hash" element={<VerifyPage />} />
            <Route path="/whitepaper" element={<WhitepaperPage />} />
            <Route path="/token/whitepaper" element={<WhitepaperPage />} />
            <Route path="/security-audit" element={<SecurityAuditPage />} />
            <Route path="/vault" element={<VaultPage />} />
            <Route path="/admin/vault" element={<AdminVaultPage />} />
            <Route path="/governance" element={<GovernancePage />} />
            <Route path="/admin/governance" element={<AdminGovernancePage />} />
          </Routes>
          <AuthModal />
          <PaymentPoller />
          <GoogleAuthCallback />
          <MissionBriefingModal />
          <ShopCartDrawer />
          {/* Token reward toaster + balance watcher (P2 mini-toast 🪙 +N) */}
          <TokenWatcher />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "rgba(15, 15, 15, 0.95)",
                border: "1px solid rgba(251, 191, 36, 0.3)",
                color: "#fbbf24",
                fontFamily: "monospace",
                fontSize: "13px",
                fontWeight: "bold",
                backdropFilter: "blur(8px)",
              },
            }}
          />
          {/* Cinematic effects — purely additive */}
          <ScrollProgressBar />
          <ScrollRevealObserver />
          <SmoothScrollAnchors />
          <MenuOverlayController />
        </BrowserRouter>
        </ImageLightboxProvider>
        </CartProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
